module.exports = __webpack_public_path__ + "img/adaptations8.10572940.png";